import styled, { css } from 'styled-components';

import { queries } from "../../../breakpoints"

export const Headline = styled.h2`
    font-family: var(--jetSansDigital-fontFamily);
    text-align: center;
    font-weight: bold;
    font-size: 36px;
`;

export const Subheadline = styled.p`
    text-align: center;
    font-size: var(--fontSize-1);
    color: var(--color-text-light);
    font-family: var(--jetSansDigital-fontFamily);
`;


export const Row = styled.div`
  font-family: var(--jetSansDigital-fontFamily);
    margin-top: 40px;
    justify-content: space-between;


  ${props => props.spacingBottom && css`
      padding-bottom: ${props.spacingBottom};
    `}
  
    ${props => props.theme === "catering" &&
        css`
          gap: 20px;
          max-width: 895px;
          margin-left: auto !important;
          margin-right: auto !important;
        `
    } 
    @media(${queries.max_break_md}) {
      flex-direction: column;
      align-items: center;
    }
  
`;

export const BoxHeadline = styled.h5`
  font-family: var(--jetSansDigital-fontFamily);
    font-weight: bold;
    margin-top: 15px;
    @media(${queries.max_break_md}){
        margin-top: initial;
    }
    
`;

export const BoxImage = styled.img`
    margin-bottom: 15px;
    max-height: 165px;
    width: auto;
    max-width: 100%;
`;

export const BoxContent = styled.div`
    padding-right: 15px;
    font-family: var(--jetSansDigital-fontFamily);
    @media(${queries.max_break_md}){
        padding-right: 0px;
    } 
`;

export const StyledCustomBox = styled.article`
    ${props => props.layout === "vertical" ? 
        css`
          font-family: var(--jetSansDigital-fontFamily);
            text-align: center;
            max-width: 300px;
            padding: 0 10px;
            margin: 15px auto;
          ${BoxImage}{
                margin-right: 10px;
                //max-width: 110px;
                max-width: ${props.imageSize?.maxWidth || '110px'};

                ${props.imageSize?.maxHeight && css`max-height: ${props.imageSize?.maxHeight}`};
                ${props.imageSize?.width && css`max-height: ${props.imageSize?.width}`};
                ${props.imageSize?.height && css`max-height: ${props.imageSize?.height}`};
              
                @media(${queries.max_break_md}){
                    margin-right: 0px;
                }
            }
        ` :
        // Horizontal layout styles
        css`
            display: flex;
            margin-bottom: 35px;
            ${BoxHeadline}{
              font-family: var(--jetSansDigital-fontFamily);
                font-size: var(--fontSize-2);
            }
            ${BoxImage}{
                margin-right: 10px;
                max-width: 110px;
                
                @media(${queries.max_break_md}){
                    margin-right: 0px;
                }
            }
            ${BoxContent}{
              font-family: var(--jetSansDigital-fontFamily);
                display: inline;
            }
        `    
    }


    ${props => props.theme === "catering" &&
            css`
          margin: 0;
          padding: 0;
          display: flex;
          max-width: ${ props => props.maxWidth ? props.maxWidth : '285px'};
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          ${BoxContent} {
            display: inline;
            ${BoxHeadline}{
              text-align: center;
            }

            p {
              text-align: center;
              /*font-weight: 400;*/
              font-family: var(--jetSansDigital-fontFamily);
            }
          }
        `
    }
    
    @media (${queries.max_break_md}){
        ${props => props.layout === "vertical" ? 
        css`
        //Vertical layout styles
        ` :
        // Horizontal layout styles
        css`
            flex-flow:column;
            text-align:center;
            ${BoxContent}{

              font-family: var(--jetSansDigital-fontFamily);
                max-width: 300px;
                margin: 0 auto;
            }
        `    
        }
    }
`;
